<template>
  <div class="w-full flex gap-2">
    <button v-if="customer.isStarred" @click="() => {starCustomer()}"
            class="text-yellow-500 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star" width="24"
            height="24"/>
    </button>
    <button v-if="!customer.isStarred" @click="() => {starCustomer()}"
            class="p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star-outline" width="24"
            height="24"/>
    </button>
    {{customer.contactDisplayName}}
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Icon} from '@iconify/vue';
import Customer from "@/models/customer/Customer";

export default defineComponent({
  setup() {
    const customer = ref<Customer>(new Customer())
    return {
      customer,
    }
  },
  components: {
    Icon
  },
  mounted() {
    /* @ts-ignore */
    this.customer = Customer.from(this.params?.data)
  },
  methods: {
    notify() {
      /* @ts-ignore */
      this.params.reload();
    },
    async starCustomer() {
      try {
        const res = await this.$http.put<Customer>(Customer.ENDPOINT + `/${this.customer.id}/star`, this.customer);
        this.customer = Customer.from(res)
        this.notify();
      } catch (e) {
        console.log(e)
      }
    }
  },
})
</script>
